import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Check } from "lucide-react";
import { business, photos } from "../../mock";

const marqueeItems = [
  "Slab Sawing", "Wall Sawing", "Core Drilling", "Bathroom Strip-Outs",
  "Kitchen Strip-Outs", "Demolition & Removal", "Trip-Hazard Grinding", "Expansion Joints",
];

export default function Hero() {
  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden bg-brand-ink">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={photos.channelPolished}
          alt="Precision concrete cutting job on a polished floor in Perth"
          className="hero-bg h-full w-full object-cover object-center"
        />
        {/* Overlays for legibility + depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/95 via-brand-ink/70 to-brand-ink/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-transparent to-brand-ink/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl flex-col justify-center px-5 sm:px-8 pt-28 pb-40">
        <div className="max-w-3xl">
          <h1 className="reveal mt-7 font-display font-semibold tracking-tight text-white text-[2.6rem] leading-[0.98] sm:text-5xl lg:text-[4rem]">
            Precision cuts, <span className="text-brand-teal">delivered</span> across Perth.
          </h1>

          <p className="reveal mt-6 max-w-md text-base sm:text-lg leading-relaxed text-white/75">
            No job too small. No call-out fees, no minimum job, and we&rsquo;ll beat any
            reputable quote by at least 10%.
          </p>

          <div className="reveal mt-9 flex flex-wrap items-center gap-4">
            <Link
              to="/quote"
              className="group inline-flex items-center gap-2 rounded-full bg-brand-teal px-7 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-white hover:text-brand-ink hover:shadow-2xl hover:shadow-black/30"
            >
              Get a Free Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <a
              href={business.phoneHref}
              className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/[0.04] px-7 py-4 text-sm font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/10"
            >
              <Phone className="h-4 w-4" /> {business.phone}
            </a>
          </div>

          {/* Trust markers */}
          <div className="reveal mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-white/70">
            <span className="flex items-center gap-2"><Check className="h-4 w-4 text-brand-teal" strokeWidth={2.5} /> No call-out fees</span>
            <span className="flex items-center gap-2"><Check className="h-4 w-4 text-brand-teal" strokeWidth={2.5} /> No minimum job</span>
            <span className="flex items-center gap-2"><Check className="h-4 w-4 text-brand-teal" strokeWidth={2.5} /> Beat any reputable quote by 10%</span>
          </div>
        </div>
      </div>

      {/* Scrolling keyword marquee at the base */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/10 bg-brand-ink/60 backdrop-blur-md">
        <div className="flex overflow-hidden py-4">
          <div className="flex shrink-0 animate-marquee items-center gap-10 pr-10">
            {[...marqueeItems, ...marqueeItems].map((item, i) => (
              <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-display text-sm font-medium uppercase tracking-[0.15em] text-white/55">{item}</span>
                <span className="h-1 w-1 rounded-full bg-brand-teal" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
